import React, { useCallback } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { Route, Redirect, RouteComponentProps } from 'react-router-dom'
import { selectAuthIsAuth, selectAuthUserRole } from 'data/Auth/selectors'
import { isAdminUserByRoleName } from 'helpers/authHelpers'
import { checkPermissions } from 'helpers/permissionsHelpers/permissionsChecker'
import { HelmetTitle } from '../HelmetTitle'

type TAdminRouteProps = {
  component: React.ComponentType<any>
  layout: React.ComponentType<any>
  [key: string]: any
  requiredPermissions?: string[]
  method?: 'all' | 'any'
  allowedRoles?: string[]
  redirectTo?: string
}

const AdminRoute = (props: TAdminRouteProps) => {
  const {
    component: Component,
    layout: Layout,
    requiredPermissions,
    method,
    allowedRoles,
    redirectTo,
    ...rest
  } = props
  const isAuth = useSelector(selectAuthIsAuth, shallowEqual)
  const userRole = useSelector(selectAuthUserRole, shallowEqual)
  const render = useCallback(
    (props: RouteComponentProps<any>) => {
      let permitted = isAuth && isAdminUserByRoleName(userRole)
      if (requiredPermissions) {
        permitted = permitted && checkPermissions(requiredPermissions, userRole, method)
      }
      if (allowedRoles) {
        permitted = permitted && allowedRoles.includes(userRole)
      }
      if (permitted)
        return (
          <Layout>
            <HelmetTitle />
            <Component {...props} />
          </Layout>
        )
      return <Redirect to={redirectTo ?? '/'} />
    },
    [Component, Layout, isAuth, requiredPermissions, userRole, method, allowedRoles, redirectTo]
  )

  return <Route {...rest} render={render} />
}

export default AdminRoute
